module.exports = __webpack_public_path__ + "img/centerLeft.69139628.png";